export default "__VITE_ASSET__$aJKcPoFoBY6iMm7b0KspA__"